import { MaskitoOptions } from '@maskito/core';

export const cardCVVMask = {
  mask: [/\d/, /\d/, /\d/],
  preprocessors: [({ elementState, data }) => ({ elementState, data: data.replace('*', '') })],
} satisfies MaskitoOptions;

export const cardNumberMask = {
  mask: [
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ],
  preprocessors: [({ elementState, data }) => ({ elementState, data: data.replace('*', '') })],
} as MaskitoOptions;

export const cardDateMask = {
  mask: [/\d/, /\d/, '/', /\d/, /\d/],
  preprocessors: [({ elementState, data }) => ({ elementState, data: data.replace('*', '') })],
} as MaskitoOptions;

export const pinMask = {
  mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
  preprocessors: [({ elementState, data }) => ({ elementState, data: data.replace('*', '') })],
} as MaskitoOptions;

export const customerIdentityMask = {
  mask: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
  preprocessors: [({ elementState, data }) => ({ elementState, data: data.replace('*', '') })],
} as MaskitoOptions;

export const descriptorMask = {
  mask: ['M', '-', /\d/, /\d/, /\d/, /\d/, /\d/],
  preprocessors: [({ elementState, data }) => ({ elementState, data: data.replace('*', '') })],
};
